import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
} from '@angular/core';
import { SimpleField } from '../../abstracts';
import { NgControl } from '@angular/forms';
import { IosToggleFieldConfig } from '../../models/fields/ios-toggle-field-config.model';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'fb-ios-toggle',
  templateUrl: './ios-toggle.component.html',
  styleUrls: ['./ios-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosToggleComponent extends SimpleField<boolean> implements OnInit {
  @Input() set config(config: IosToggleFieldConfig) {
    this._config = config;
    this.backgroundColor = config.backgroundColor;
  }

  @Input() set backgroundColor(color: string) {
    if (!color) return;
    this.toggleBackground = color;
  }

  @Output() valueChanges: EventEmitter<boolean> = new EventEmitter<boolean>();
  @HostBinding('style.--toggle-background') toggleBackground: string = '#1bb876';

  id?: string;
  _config?: IosToggleFieldConfig;
  setFlag: boolean = false;

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    protected override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  ngOnInit(): void {
    this.id = Math.random().toString(36).substring(2);

    this.ngControl.control.valueChanges.pipe(untilComponentDestroyed(this)).subscribe((value: boolean) => {
      this.valueChanges.emit(Boolean(value));
    });
  }
}
